module.exports = __webpack_public_path__ + "img/gallery-tenant.2a35fe3a.png";